module.exports = __webpack_public_path__ + "img/mulher-com-tablet.7437e48.png";